// Recovered compiled webpack factory 73879. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "addPathPrefix", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(5240);
  function a(e, t) {
    if (!e.startsWith("/") || !t) return e;
    let { pathname: r, query: a, hash: o } = (0, n.parsePath)(e);
    return "" + t + r + a + o;
  }
}
